import { isProductOptionModelList } from '../../../../types/helpers/isProductOptionModelList.mjs';
import { ValidationResult } from '../types/validation-result.mjs';

function styleValidator(productOption, skinInput, hideImages, hideDescriptions) {
    const result = new ValidationResult();
    // If every key is a hex code and there are no images, render a color-swatch
    const rangedOver = getRangedOverrides(productOption, skinInput);
    const listOver = getListOverrides(hideImages, productOption, result, rangedOver.style, rangedOver.skin, hideDescriptions);
    return {
        messages: result.messages,
        style: listOver.style,
        skin: listOver.skin,
    };
}
function getRangedOverrides(productOptions, skinInput) {
    return { style: productOptions.style, skin: skinInput };
}
function getListOverrides(hideImages, productOption, result, style, skin, hideDescriptions) {
    if (isProductOptionModelList(productOption)) {
        if (hideImages &&
            productOption.choices.length > 0 &&
            productOption.choices.every((x) => /^#[0-9A-F]{6}(?:\/#[0-9A-F]{6})?$/i.test(x.key))) {
            result.addValidation(`The ${style} ${skin} was converted to a standard color-swatch as all keys have a hex code`);
            style = "color-swatch";
            skin = "standard";
        }
        if (style === "buttons" && skin === "wide" && hideImages && hideDescriptions) {
            result.addValidation(`The 'button' skin was changed to 'tight' from 'wide' because there are no images, descriptions or savings to display.`);
            skin = "tight";
        }
        const QuantityDropdownSkin = "standard";
        if (style === "dropdown" && productOption.key === "Quantity" && skin !== QuantityDropdownSkin) {
            result.addValidation(`The "dropdown" skin was changed to "${QuantityDropdownSkin}" from ${skin} because "Quantity" dropdowns should always use "${QuantityDropdownSkin}" skin.`);
            skin = QuantityDropdownSkin;
        }
    }
    return { style, skin };
}

export { styleValidator };
//# sourceMappingURL=style-validator.mjs.map
